module.exports = __webpack_public_path__ + "images/emoji/bowling.b4bb00467d5410e8de63.png";